import { objectToEnum } from "@euroland/libs/utils";

/**
 * @type {{
 *    adaptive: "adaptive",
 *    compact: "compact",
 *    perspective: "perspective",
 *    quadrata: "quadrata",
 *    victor: "victor",
 * }}
 */
export const TOOL_TEMPLATE = {
  adaptive: "adaptive",
  compact: "compact",
  perspective: "perspective",
  quadrata: "quadrata",
  victor: "victor",
};
export const REFRESH_TIMEOUT = 60;

export const TIME_FORMAT_DEFAULT = "HH:mm:ss";

export const TRADE_HISTORY_FIELD = objectToEnum({
  time: "Time",
  volume: "Volume",
  price: "Price",
  buyer: "Buyer",
  seller: "Seller",
});

export const MARKET_STATUS = {
  OPEN: "Open",
  CLOSE: "Close",
};

export const PRICE_STATUS = {
  UP: 1,
  DOWN: 2,
};

export const DATA_LISTS = {
  "TIME":"lastUpdatedDate",
  "CURRENCY":"currencyCode",
  "MARKET":"marketName",
  "MARKET_STATUS":"marketStatus",
  "ISIN":"iSIN",
  "SYMBOL":"ticker",
  "BID":"bid",
  "BID_SIZE":"bidSize",
  "ASK":"ask",
  "ASK_SIZE":"askSize",
  "OPEN":"open",
  "LAST":"last",
  "CHANGE":"change",
  "CHANGE_PERCENT":"changePercentage",
  "HIGH":"high",
  "LOW":"low",
  "VOLUME":"volume",
  "TOTAL_TRADES":"totalTrades",
  "PREVIOUS_CLOSE":"prevClose",
  "YTD_HIGH":"highYTD",
  "YTD_LOW":"lowYTD",
  "WEEKS_52_HIGH":"high52W",
  "WEEKS_52_LOW":"low52W",
  "ALL_TIME_HIGH":"allTimeHigh",
  "ALL_TIME_LOW":"allTimeLow",
  "YTD_PERCENT":"yTD",
  "WEEKS_52_PERCENT":"percent52W",
  "LIST":"listName",
  "INDUSTRY":"industry",
  "NUMBER_OF_SHARES":"noShares",
  "MARKET_CAP":"marketCap",
  "LOT_SIZE":"lotSize",
  "P_E":"pE",
  "AVERAGE_PRICE":"vWAP",
  "TURNOVER":"todayTurnover"
};


export const LIST_OF_DATA_STRING = {
  'currencyCode':'currencyCode',
  'iSIN':'iSIN',
  'industry':'industry',
  'listName':'listName',
  'marketAbbreviation':'marketAbbreviation',
  'marketName':'marketName',
  'marketStatus':'marketStatus',
  'shareName':'shareName',
  'ticker':'ticker'
};

export const KEY_BOARD = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ENTER: "Enter",
  SPACE: " ",
  ESCAPE: "Escape",
  END: "End",
  HOME: "Home",
};

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const SHORT_MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];


export const SHORT_DATE_FORMAT = "DD-MMMM-YYYY";
export const SHORT_DATE_MOBILE_FORMAT = "DD-MM-YYYY";
export const DATE_FORMAT_PARAM = "YYYY-MM-DD";

export const FORMAT_NUMBER = "#,##0.0000";
export const POSITIVE_NUMBER_FORMAT = 'n';
export const POSITIVE_CHANGE_NUMBER_FORMAT = '+n';

export const LONG_DATE_SCREEN_READER = "dddd, MMMM DD YYYY HH:mm:ss"
export const MARKET_CAP_SETTING = {
  "Exact": "marketCap",
  "Hundreds": "marketCapHun",
  "Thousands": "marketCapThou",
  "Millions": "marketCapMil",
  "Billion": "marketCapBil",
  "Default": "marketCap"
}
export const NUMBER_OF_SHARES_SETTING = {
  "Exact": "noShares",
  "Hundreds": "numberOfSharesHun",
  "Thousands": "numberOfSharesThou",
  "Millions": "numberOfSharesMil",
  "Billion": "numberOfSharesBil",
  "Default": "noShares"
}